import { ITheme } from '../../themes';
import { TooltipModeModel } from '../tooltip.model';

export const getTooltipArrowFill = (
  theme: ITheme,
  mode: TooltipModeModel
): string => {
  switch (mode) {
    case 'white':
      return theme.COLOR.WHITE;
    case 'dark':
      return '#333333';
  }
};
